import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';

// import { environment } from '../../../environments/environment';
import { environment } from 'src/environments/environment';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { SessionService } from '../../_shared/services/session.service';

import { UserService } from '../../users/shared/user.service';

import { CompanySelectorComponent } from '../../_shared/components/company-selector.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [SharedModule, CompanySelectorComponent],
})
export class HeaderComponent {
  @Input() currentUser;

  showSideBar = true;

  private chatLoaded = false;

  constructor(
    private router: Router,
    private alertService: AlertService,
    private sessionService: SessionService,
    private userService: UserService,
    @Inject('VersioningService') private VersioningServiceAjs: any
  ) {}

  toogleSideBarMenu() {
    if (this.showSideBar) {
      document.getElementById('sidebar').style.width = '0';
      document.getElementById('content').style.marginLeft = '64px';

      document.getElementById('container').classList.add('sidebar-closed');

      this.closeAllSubMenus(true);
    } else {
      // Open sidebar
      document.getElementById('sidebar').style.width = '200px';
      document.getElementById('content').style.marginLeft = '200px';

      document.getElementById('container').classList.remove('sidebar-closed');
    }

    this.showSideBar = !this.showSideBar;
  }

  updateUserAppVersion() {
    this.userService.updateUserAppVersion(this.currentUser.id).subscribe(() => {
      this.alertService.open('VERSION_UPDATED');

      location.reload(); // true refresh cached files?
    });

    // this.UserService.updateUserAppVersion(this.currentUser.id).then(() => {
    //   location.reload(); // true refresh cached files?
    // });
  }

  openUpdateUserAppVersionModal() {
    // Use a service different than admin/
    this.VersioningServiceAjs.openUpdateUserAppVersionModal(this.currentUser.id);
  }

  openChat() {
    // To load dinamically - it takes more time
    /*var script = document.createElement('script');
            script.type = 'text/javascript';
            script.setAttribute('data-cfasync', false);
            script.setAttribute('src', 'https://tim.user.com/widget.js');
            script.onload = function() {
                loadChat();
            };
            document.body.appendChild(script);*/

    const loadChat = () => {
      /*UE.pageHit({
        apiKey: 'SFPaLS',
        name: currentUser.first_name + ' ' + currentUser.last_name,
        email: currentUser.email,
        user_id: currentUser.id,
        company: {
          name: this.sessionService.getSelectedAccountCompany().commercial_name,
        },
        onLoad() {
          // console.log("onLoad");
          chatLoaded = true;
          userengage('widget.open');
        },
        // onOpen() {
            // console.log("onOpen");
        // },
        onClose() {
          // console.log("onClose");
          userengage('widget.hide');
        },
      });*/
    };

    const reOpenChat = () => {
      // userengage('widget.show');
    };

    if (!this.chatLoaded) {
      loadChat();
    } else {
      reOpenChat();
    }
  }

  logout() {
    // QA/Production only
    if (environment.name !== 'development') {
      // User.com chat
      // UE.destroy({});
    }

    this.sessionService.logout().subscribe(() => {
      // The backend doesn't care about logouts, delete the token and you're good to go. ??
      this.sessionService.deleteCurrentUser();

      this.router.navigate(['/ng/login']); // reload ??
    });
  }

  private closeAllSubMenus(keepCurrentClass) {
    let list = document.querySelectorAll('#nav > li');

    for (let i = 0; i < list.length; i++) {
      if (!keepCurrentClass) {
        list[i].classList.remove('open');
      }

      let subMenu = list[i].querySelector<HTMLElement>('.sub-menu');

      if (subMenu && subMenu.classList.contains('active')) {
        subMenu.classList.remove('active');
        subMenu.style.height = '0px';

        list[i].querySelector('a').classList.remove('active');
      }
    }
  }
}
